import { Driver } from '../../../API/types/Drivers';

export const generatePreviewLicenseNumber = (license: string | undefined): string => {
  if (license?.length) {
    return license;
  }

  return 'Add vehicle license number';
};

export const generatePreviewModel = (model: string | undefined): string => {
  if (model?.length) {
    return model;
  }

  return 'Add vehicle model';
};

export const generateUnassignedDriversTitle = (drivers: Driver[] | undefined): string => {
  if (!drivers?.length) {
    return 'Drivers';
  }
  const isPlural = drivers.length === 1;
  return `${drivers.length} unassigned ${isPlural ? 'driver' : 'drivers'}`;
};
